export const UPDATE_USER = "UPDATE_USER"

export const SAVE_USER = "SAVE_USER"
